"use strict";
/*
  based on: https://github.com/rzeigler/waveguide-streams/blob/master/src/stream.ts
  credits to original author
 */
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var fp_ts_1 = require("fp-ts");
var stream_1 = require("stream");
var T = __importStar(require("../effect"));
var effect_1 = require("../effect");
var deferred = __importStar(require("../deferred"));
var M = __importStar(require("../managed"));
var cq = __importStar(require("../queue"));
var ref = __importStar(require("../ref"));
var semaphore = __importStar(require("../semaphore"));
var sink_1 = require("./sink");
var step_1 = require("./step");
var su = __importStar(require("./support"));
exports.su = su;
var Do_1 = require("fp-ts-contrib/lib/Do");
var Apply_1 = require("fp-ts/lib/Apply");
var toS = function (_) { return _; };
var fromS = function (_) { return _; };
// The contract of a Stream's fold is that state is preserved within the lifecycle of the managed
// Therefore, we must track the offset in the array via a ref
// This allows, for instance, this to work with transduce
function arrayFold(as) {
    return M.encaseEffect(effect_1.effect.map(ref.makeRef(0), function (cell) { return function (initial, cont, f) {
        function step(current) {
            /* istanbul ignore else */
            if (cont(current)) {
                return fp_ts_1.pipeable.pipe(cell.modify(function (i) { return [i, i + 1]; }), // increment the i
                T.chain(function (i) {
                    return i < as.length ? effect_1.effect.chain(f(current, as[i]), step) : T.pure(current);
                }));
            }
            else {
                return T.pure(current);
            }
        }
        return step(initial);
    }; }));
}
function iteratorSource(iter) {
    return T.sync(function () {
        var n = iter.next();
        if (n.done) {
            return fp_ts_1.option.none;
        }
        return fp_ts_1.option.some(n.value);
    });
}
function rangeIterator(start, interval, end) {
    var current;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                current = start;
                _a.label = 1;
            case 1:
                if (!(!end || current < end)) return [3 /*break*/, 3];
                return [4 /*yield*/, current];
            case 2:
                _a.sent();
                current += interval || 1;
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
/**
 * Create a Stream from a source A action.
 *
 * The contract is that the acquisition of the resource should produce a Wave that may be repeatedly evaluated
 * during the scope of the Managed
 * If there is more data in the stream, the Wave should produce some(A) otherwise it should produce none.
 * Once it produces none, it will not be evaluated again.
 * @param r
 */
function fromSource(r) {
    return toS(M.managed.map(r, function (pull) {
        function fold(initial, cont, step) {
            return cont(initial)
                ? fp_ts_1.pipeable.pipe(pull, T.chain(function (out) {
                    return fp_ts_1.pipeable.pipe(out, fp_ts_1.option.fold(function () { return T.pure(initial); }, function (a) { return effect_1.effect.chain(step(initial, a), function (next) { return fold(next, cont, step); }); }));
                }))
                : T.pure(initial);
        }
        return fold;
    }));
}
exports.fromSource = fromSource;
/**
 * Create a stream from an Array
 * @param as
 */
function fromArray(as) {
    return toS(arrayFold(as));
}
exports.fromArray = fromArray;
/**
 * Create a stream from an iterator
 * @param iter
 */
function fromIterator(iter) {
    return fp_ts_1.pipeable.pipe(M.encaseEffect(T.sync(iter)), M.map(iteratorSource), fromSource);
}
exports.fromIterator = fromIterator;
/**
 * Create a stream that emits the elements in a range
 * @param start
 * @param interval
 * @param end
 */
function fromRange(start, interval, end) {
    return fromIterator(function () { return rangeIterator(start, interval, end); });
}
exports.fromRange = fromRange;
/**
 * Create a stream from an existing iterator
 * @param iter
 */
function fromIteratorUnsafe(iter) {
    return fromIterator(function () { return iter; });
}
exports.fromIteratorUnsafe = fromIteratorUnsafe;
/**
 * Create a stream that emits a single element
 * @param a
 */
function once(a) {
    function fold(initial, cont, f) {
        /* istanbul ignore else */
        if (cont(initial)) {
            return f(initial, a);
        }
        else {
            return T.pure(initial);
        }
    }
    return toS(M.pure(fold));
}
exports.once = once;
/**
 * Create a stream that emits As as fast as possible
 *
 * Be cautious when using this. If your entire pipeline is full of synchronous actions you can block the main
 * thread until the stream runs to completion (or forever) using this
 * @param a
 */
function repeatedly(a) {
    function fold(initial, cont, f) {
        function step(current) {
            if (cont(current)) {
                return T.shiftAfter(effect_1.effect.chain(f(current, a), step));
            }
            return T.shiftAfter(T.pure(current));
        }
        return step(initial);
    }
    return toS(M.pure(fold));
}
exports.repeatedly = repeatedly;
function periodically(ms) {
    return fp_ts_1.pipeable.pipe(M.encaseEffect(ref.makeRef(-1)), M.map(function (r) {
        return fp_ts_1.pipeable.pipe(T.delay(r.update(function (n) { return n + 1; }), ms), T.map(fp_ts_1.option.some));
    }), fromSource);
}
exports.periodically = periodically;
/**
 * A stream that emits no elements an immediately terminates
 */
exports.empty = toS(M.pure(function (initial, _cont, _f) {
    return T.pure(initial);
}));
/**
 * Create a stream that evalutes w to emit a single element
 * @param w
 */
function encaseEffect(w) {
    function fold(initial, cont, step) {
        /* istanbul ignore else */
        if (cont(initial)) {
            return fp_ts_1.pipeable.pipe(w, T.chain(function (a) { return step(initial, a); }));
        }
        else {
            return T.pure(initial);
        }
    }
    return toS(M.pure(fold));
}
exports.encaseEffect = encaseEffect;
/**
 * Create a stream that immediately fails
 * @param e
 */
function raised(e) {
    return encaseEffect(T.raiseError(e));
}
exports.raised = raised;
/**
 * Create a stream that immediately aborts
 * @param e
 */
function aborted(e) {
    return encaseEffect(T.raiseAbort(e));
}
exports.aborted = aborted;
/**
 * Create a stream that immediately emits either 0 or 1 elements
 * @param opt
 */
function fromOption(opt) {
    return fp_ts_1.pipeable.pipe(opt, fp_ts_1.option.fold(fp_ts_1["function"].constant(exports.empty), once));
}
exports.fromOption = fromOption;
/**
 * Zip all stream elements with their index ordinals
 * @param stream
 */
function zipWithIndex(stream) {
    return toS(M.managed.map(fromS(stream), function (fold) {
        function zipFold(initial, cont, f) {
            var folded = fold([initial, 0], function (s) { return cont(s[0]); }, function (_a, a) {
                var s = _a[0], i = _a[1];
                return effect_1.effect.map(f(s, [a, i]), function (s) { return [s, i + 1]; });
            });
            return effect_1.effect.map(folded, function (s) { return s[0]; });
        }
        return zipFold;
    }));
}
exports.zipWithIndex = zipWithIndex;
/**
 * Create a stream that emits all the elements of stream1 followed by all the elements of stream2
 * @param stream1
 * @param stream2
 */
function concatL_(stream1, stream2) {
    var w1 = fromS(stream1);
    var w2 = function () { return fromS(stream2()); };
    function fold(initial, cont, step) {
        return fp_ts_1.pipeable.pipe(M.use(w1, function (fold1) { return fold1(initial, cont, step); }), T.chain(function (intermediate) {
            /* istanbul ignore else */
            if (cont(intermediate)) {
                return M.use(w2(), function (fold2) { return fold2(intermediate, cont, step); });
            }
            else {
                return T.pure(intermediate);
            }
        }));
    }
    return toS(M.pure(fold));
}
function concatL(stream2) {
    return function (s) { return concatL_(s, stream2); };
}
exports.concatL = concatL;
/**
 * Strict form of concatL
 * @param stream1
 * @param stream2
 */
function concat_(stream1, stream2) {
    return concatL_(stream1, fp_ts_1["function"].constant(stream2));
}
function concat(stream2) {
    return function (s) { return concat_(s, stream2); };
}
exports.concat = concat;
/**
 * Creates a stream that repeatedly emits the elements of a stream forever.
 *
 * The elements are not cached, any effects required (i.e. opening files or sockets) are repeated for each cycle
 * @param stream
 */
function repeat(stream) {
    return concatL_(stream, function () { return repeat(stream); });
}
exports.repeat = repeat;
function map_(stream, f) {
    return toS(M.managed.map(fromS(stream), function (outer) { return function (initial, cont, step) { return outer(initial, cont, function (s, a) { return step(s, f(a)); }); }; }));
}
/**
 * Map the elements of a stream
 * @param stream
 * @param f
 */
function map(f) {
    return function (stream) { return map_(stream, f); };
}
exports.map = map;
/**
 * Map every element emitted by stream to b
 * @param stream
 * @param b
 */
function as_(stream, b) {
    return map_(stream, fp_ts_1["function"].constant(b));
}
function as(b) {
    return function (s) { return as_(s, b); };
}
exports.as = as;
/**
 * Filter the elements of a stream by a predicate
 * @param stream
 * @param f
 */
function filter_(stream, f) {
    return toS(M.managed.map(fromS(stream), function (outer) { return function (initial, cont, step) { return outer(initial, cont, function (s, a) { return (f(a) ? step(s, a) : T.pure(s)); }); }; }));
}
function filter(f) {
    return function (s) { return filter_(s, f); };
}
exports.filter = filter;
/**
 * Filter the stream so that only items that are not equal to the previous item emitted are emitted
 * @param eq
 */
function distinctAdjacent_(stream, eq) {
    return toS(M.managed.map(fromS(stream), function (base) { return function (initial, cont, step) {
        var init = [initial, fp_ts_1.option.none];
        var c = function (_a) {
            var s = _a[0];
            return cont(s);
        };
        function stp(current, next) {
            return fp_ts_1.pipeable.pipe(current[1], fp_ts_1.option.fold(
            // We haven't seen anything so just return
            function () { return effect_1.effect.map(step(current[0], next), function (s) { return [s, fp_ts_1.option.some(next)]; }); }, function (seen) {
                return eq.equals(seen, next)
                    ? T.pure(current)
                    : effect_1.effect.map(step(current[0], next), function (s) { return [s, fp_ts_1.option.some(next)]; });
            }));
        }
        return effect_1.effect.map(base(init, c, stp), function (s) { return s[0]; });
    }; }));
}
function distinctAdjacent(eq) {
    return function (s) { return distinctAdjacent_(s, eq); };
}
exports.distinctAdjacent = distinctAdjacent;
/**
 * Fold the elements of this stream together using an effect.
 *
 * The resulting stream will emit 1 element produced by the effectful fold
 * @param stream
 * @param f
 * @param seed
 */
function foldM_(stream, f, seed) {
    return toS(M.managed.map(fromS(stream), function (base) { return function (initial, cont, step) {
        /* istanbul ignore else */
        if (cont(initial)) {
            return effect_1.effect.chain(base(seed, fp_ts_1["function"].constant(true), f), function (result) { return step(initial, result); });
        }
        else {
            return T.pure(initial);
        }
    }; }));
}
function foldM(seed, f) {
    return function (s) { return foldM_(s, f, seed); };
}
exports.foldM = foldM;
/**
 * Fold the elements of a stream together purely
 * @param stream
 * @param f
 * @param seed
 */
function fold_(stream, f, seed) {
    return foldM_(stream, function (b, a) { return T.pure(f(b, a)); }, seed);
}
function t2(a, b) {
    return [a, b];
}
function fold(seed, f) {
    return function (s) { return fold_(s, f, seed); };
}
exports.fold = fold;
/**
 * Scan across the elements the stream.
 *
 * This is like foldM but emits every intermediate seed value in the resulting stream.
 * @param stream
 * @param f
 * @param seed
 */
function scanM_(stream, f, seed) {
    return concat_(once(seed), toS(fp_ts_1.pipeable.pipe(M.zip(fromS(stream), M.encaseEffect(ref.makeRef(seed))), M.map(function (_a) {
        var base = _a[0], accum = _a[1];
        function fold(initial, cont, step) {
            /* istanbul ignore else */
            if (cont(initial)) {
                // We need to figure out how to drive the base fold for a single step
                // Thus, we switch state from true to false on execution
                return fp_ts_1.pipeable.pipe(accum.get, T.chain(function (b) {
                    return base(t2(b, true), function (s) { return s[1]; }, function (s, a) { return effect_1.effect.map(f(s[0], a), function (r) { return t2(r, false); }); });
                }), T.chain(
                // If this is still true, we didn't consume anything so advance
                function (s) {
                    return s[1]
                        ? T.pure(initial)
                        : T.applySecond(accum.set(s[0]), effect_1.effect.chain(step(initial, s[0]), function (next) { return fold(next, cont, step); }));
                }));
            }
            else {
                return T.pure(initial);
            }
        }
        return fold;
    }))));
}
function scanM(seed, f) {
    return function (s) { return scanM_(s, f, seed); };
}
exports.scanM = scanM;
/**
 * Purely scan a stream
 * @param stream
 * @param f
 * @param seed
 */
function scan_(stream, f, seed) {
    return scanM_(stream, function (b, a) { return T.pure(f(b, a)); }, seed);
}
function scan(seed, f) {
    return function (s) { return scan_(s, f, seed); };
}
exports.scan = scan;
function chain_(stream, f) {
    return toS(M.managed.map(fromS(stream), function (outerfold) { return function (initial, cont, step) {
        return outerfold(initial, cont, function (s, a) {
            /* istanbul ignore next */
            if (cont(s)) {
                var inner = f(a);
                return M.use(fromS(inner), function (innerfold) { return innerfold(s, cont, step); });
            }
            else {
                return T.pure(s);
            }
        });
    }; }));
}
/**
 * Monadic chain on a stream
 * @param stream
 * @param f
 */
function chain(f) {
    return function (stream) {
        return toS(M.managed.map(fromS(stream), function (outerfold) { return function (initial, cont, step) {
            return outerfold(initial, cont, function (s, a) {
                /* istanbul ignore next */
                if (cont(s)) {
                    var inner = f(a);
                    return M.use(fromS(inner), function (innerfold) { return innerfold(s, cont, step); });
                }
                else {
                    return T.pure(s);
                }
            });
        }; }));
    };
}
exports.chain = chain;
/**
 * Flatten a stream of streams
 * @param stream
 */
function flatten(stream) {
    return chain_(stream, fp_ts_1["function"].identity);
}
exports.flatten = flatten;
/**
 * Map each element of the stream effectfully
 * @param stream
 * @param f
 */
function mapM_(stream, f) {
    return chain_(stream, function (a) { return encaseEffect(f(a)); });
}
function mapM(f) {
    return function (s) { return mapM_(s, f); };
}
exports.mapM = mapM;
/**
 * A stream that emits no elements but never terminates.
 */
exports.never = mapM_(once(undefined), fp_ts_1["function"].constant(T.never));
/**
 * Transduce a stream via a sink.
 *
 * This repeatedly run a sink to completion on the elements of the input stream and emits the result of each run
 * Leftovers from a previous run are fed to the next run
 *
 * @param stream
 * @param sink
 */
function transduce_(stream, sink) {
    return toS(M.managed.map(fromS(stream), function (base) { return function (initial, cont, step) {
        function feedSink(foldState, sinkState, chunk) {
            return effect_1.effect.chain(sink_1.stepMany(sink, sinkState, chunk), function (nextSinkStep) {
                return step_1.isSinkCont(nextSinkStep)
                    ? // We need to let more data in to drive the sink
                        T.pure([foldState, nextSinkStep.state, true])
                    : // We have a completion, so extract the value and then use it to advance the fold state
                        fp_ts_1.pipeable.pipe(step_1.sinkStepState(nextSinkStep), sink.extract, T.chain(function (b) { return step(foldState, b); }), T.chain(function (nextFoldState) {
                            var leftover = step_1.sinkStepLeftover(nextSinkStep);
                            // We will re-initialize the sink
                            return fp_ts_1.pipeable.pipe(sink.initial, T.chain(function (nextNextSinkState) {
                                if (cont(nextFoldState) && leftover.length > 0) {
                                    return feedSink(nextFoldState, nextNextSinkState.state, leftover);
                                }
                                else {
                                    return T.pure([
                                        nextFoldState,
                                        nextNextSinkState.state,
                                        false
                                    ]);
                                }
                            }));
                        }));
            });
        }
        var derivedInitial = effect_1.effect.map(sink.initial, function (initSink) { return [initial, step_1.sinkStepState(initSink), false]; });
        return fp_ts_1.pipeable.pipe(derivedInitial, T.chain(function (init) {
            return base(init, function (s) { return cont(s[0]); }, function (s, a) { return feedSink(s[0], s[1], [a]); });
        }), T.chain(function (_a) {
            var foldState = _a[0], sinkState = _a[1], extract = _a[2];
            return extract && cont(foldState)
                ? effect_1.effect.chain(sink.extract(sinkState), function (b) { return step(foldState, b); })
                : T.pure(foldState);
        }));
    }; }));
}
function transduce(sink) {
    return function (s) { return transduce_(s, sink); };
}
exports.transduce = transduce;
/**
 * Drop some number of elements from a stream
 *
 * Their effects to be produced still occur in the background
 * @param stream
 * @param n
 */
function drop_(stream, n) {
    return fp_ts_1.pipeable.pipe(zipWithIndex(stream), filter(function (_a) {
        var _ = _a[0], i = _a[1];
        return i >= n;
    }), map(function (_a) {
        var a = _a[0];
        return a;
    }));
}
function drop(n) {
    return function (s) { return drop_(s, n); };
}
exports.drop = drop;
/**
 * Take some number of elements of a stream
 * @param stream
 * @param n
 */
function take_(stream, n) {
    return toS(M.managed.map(fromS(stream), function (fold) { return function (initial, cont, step) {
        return effect_1.effect.map(fold(t2(initial, 0), function (t2s) { return t2s[1] < n && cont(t2s[0]); }, function (s, a) { return effect_1.effect.map(step(s[0], a), function (next) { return t2(next, s[1] + 1); }); }), function (t2s) { return t2s[0]; });
    }; }));
}
function take(n) {
    return function (s) { return take_(s, n); };
}
exports.take = take;
/**
 * Take elements of a stream while a predicate holds
 * @param stream
 * @param pred
 */
function takeWhile_(stream, pred) {
    return toS(M.managed.map(fromS(stream), function (fold) { return function (initial, cont, step) {
        return effect_1.effect.map(fold(t2(initial, true), function (t2s) { return t2s[1] && cont(t2s[0]); }, function (s, a) {
            return pred(a)
                ? effect_1.effect.map(step(s[0], a), function (next) { return t2(next, true); })
                : T.pure(t2(s[0], false));
        }), function (t2s) { return t2s[0]; });
    }; }));
}
function takeWhile(pred) {
    return function (s) { return takeWhile_(s, pred); };
}
exports.takeWhile = takeWhile;
/**
 * Take elements from a stream until a given effect resolves.
 *
 * @param until The effect that will terminate the stream
 * @param stream The stream
 */
function takeUntil_(stream, until) {
    var wrappedUntil = as({ type: "until" })(encaseEffect(until));
    var wrappedStream = fp_ts_1.pipeable.pipe(stream, map(function (value) { return ({ type: "stream", value: value }); }));
    return fp_ts_1.pipeable.pipe(mergeAll([wrappedUntil, wrappedStream]), takeWhile(function (wrapped) { return wrapped.type === "stream"; }), filter(function (wrapped) { return wrapped.type === "stream"; }), map(function (wrapped) { return wrapped.value; }));
}
function takeUntil(until) {
    return function (s) { return takeUntil_(s, until); };
}
exports.takeUntil = takeUntil;
/**
 * Push a stream into a sink to produce the sink's result
 * @param stream
 * @param sink
 */
function into_(stream, sink) {
    return M.use(fromS(stream), function (fold) {
        return fp_ts_1.pipeable.pipe(sink.initial, T.chain(function (init) { return fold(init, step_1.isSinkCont, function (s, a) { return sink.step(s.state, a); }); }), T.map(function (s) { return s.state; }), T.chain(sink.extract));
    });
}
function into(sink) {
    return function (s) { return into_(s, sink); };
}
exports.into = into;
/**
 * Push a stream into a sink to produce the sink's result
 * @param stream
 * @param managedSink
 */
function intoManaged_(stream, managedSink) {
    return M.use(managedSink, function (sink) { return into_(stream, sink); });
}
function intoManaged(managedSink) {
    return function (s) { return intoManaged_(s, managedSink); };
}
exports.intoManaged = intoManaged;
/**
 * Push a stream in a sink to produce the result and the leftover
 * @param stream
 * @param sink
 */
function intoLeftover_(stream, sink) {
    return M.use(stream, function (fold) {
        return fp_ts_1.pipeable.pipe(sink.initial, T.chain(function (init) { return fold(init, step_1.isSinkCont, function (s, a) { return sink.step(s.state, a); }); }), T.chain(function (end) {
            return effect_1.effect.map(sink.extract(end.state), function (b) { return [b, step_1.sinkStepLeftover(end)]; });
        }));
    });
}
function intoLeftover(sink) {
    return function (s) { return intoLeftover_(s, sink); };
}
exports.intoLeftover = intoLeftover;
function sinkQueue(stream) {
    return M.managed.chain(M.zip(
    // 0 allows maximum backpressure throttling (i.e. a reader must be waiting already to produce the item)
    M.encaseEffect(cq.boundedQueue(0)), M.encaseEffect(deferred.makeDeferred())), function (_a) {
        var q = _a[0], latch = _a[1];
        var write = effect_1.effect.foldExit(into_(map_(stream, fp_ts_1.option.some), sink_1.queueSink(q)), function (c) { return latch.cause(c); }, fp_ts_1["function"].constant(q.offer(fp_ts_1.option.none)));
        return M.as(M.fiber(write), [q, latch]);
    });
}
/**
 * Zip two streams together termitating when either stream is exhausted
 * @param as
 * @param bs
 * @param f
 */
function zipWith_(as, bs, f) {
    var source = M.zipWith(sinkQueue(as), sinkQueue(bs), function (_a, _b) {
        var aq = _a[0], alatch = _a[1];
        var bq = _b[0], blatch = _b[1];
        var atake = fp_ts_1.pipeable.pipe(aq.take, T.chainTap(function (opt) {
            return fp_ts_1.pipeable.pipe(opt, fp_ts_1.option.fold(
            // Confirm we have seen the last element
            function () { return alatch.done(fp_ts_1.option.none); }, function () { return T.unit; } // just keep going
            ));
        }));
        var agrab = T.raceFirst(atake, alatch.wait);
        var btake = fp_ts_1.pipeable.pipe(bq.take, T.chainTap(function (opt) {
            return fp_ts_1.pipeable.pipe(opt, fp_ts_1.option.fold(
            // Confirm we have seen the last element
            function () { return blatch.done(fp_ts_1.option.none); }, function () { return T.unit; } // just keep going
            ));
        }));
        var bgrab = T.raceFirst(btake, blatch.wait);
        return T.effect.zipWith(agrab, bgrab, function (aOpt, bOpt) {
            return fp_ts_1.option.option.chain(aOpt, function (a) { return fp_ts_1.option.option.map(bOpt, function (b) { return f(a, b); }); });
        });
    });
    return fromSource(source);
}
function zipWith(bs, f) {
    return function (s) { return zipWith_(s, bs, f); };
}
exports.zipWith = zipWith;
/**
 * zipWith to form tuples
 * @param as
 * @param bs
 */
function zip_(as, bs) {
    return zipWith_(as, bs, function (a, b) { return [a, b]; });
}
function zip(bs) {
    return function (as) { return zip_(bs, as); };
}
exports.zip = zip;
/**
 * Given a queue and a Deferred for signalling exits construct a Wave of a pull operation.
 * The protocol is that errors are propogated through the latch and the latch can be used to track completion.
 * Once a none is received through the queue, this read process completes the latch with none to to make the finish durable
 * in the face of repeated reads (which is important for peel)
 *
 * @param queue
 * @param breaker
 */
function queueBreakerSource(queue, breaker) {
    var take = fp_ts_1.pipeable.pipe(queue.take, T.chainTap(function (opt) {
        return fp_ts_1.pipeable.pipe(opt, fp_ts_1.option.fold(
        // Confirm we have seen the last element by closing the breaker so subsequent reads see it
        fp_ts_1["function"].constant(breaker.done(fp_ts_1.option.none)), 
        // do nothing to the breaker if we got an element
        fp_ts_1["function"].constant(T.unit)));
    }));
    return T.raceFirst(take, breaker.wait);
}
/**
 * Construct a Source for a Stream.
 * During the scope of the Managed, Wave will repeatedly pull items from a queue being managed in the background
 * @param stream
 */
function streamQueueSource(stream) {
    return M.managed.map(sinkQueue(stream), function (_a) {
        var q = _a[0], breaker = _a[1];
        return queueBreakerSource(q, breaker);
    });
}
/**
 * Feed a stream into a sink to produce a value.
 *
 * Emits the value and a 'remainder' stream that includes the rest of the elements of the input stream.
 * @param stream
 * @param sink
 */
function peel_(stream, sink) {
    return toS(M.managed.chain(streamQueueSource(stream), function (pull) {
        var pullStream = fromSource(M.pure(pull));
        // We now have a shared pull instantiation that we can use as a sink to drive and return as a stream
        return fromS(fp_ts_1.pipeable.pipe(encaseEffect(intoLeftover_(pullStream, sink)), map(function (_a) {
            var b = _a[0], left = _a[1];
            return [b, concat_(fromArray(left), pullStream)];
        })));
    }));
}
function peel(sink) {
    return function (s) { return peel_(s, sink); };
}
exports.peel = peel;
function peelManaged_(stream, managedSink) {
    return toS(M.managed.chain(managedSink, function (sink) { return fromS(peel_(stream, sink)); }));
}
function peelManaged(managedSink) {
    return function (s) { return peelManaged_(s, managedSink); };
}
exports.peelManaged = peelManaged;
function interruptFiberSlot(slot) {
    return effect_1.effect.chain(slot.get, function (optFiber) {
        return fp_ts_1.pipeable.pipe(optFiber, fp_ts_1.option.fold(function () { return T.pure(fp_ts_1.option.none); }, function (f) { return T.effect.map(f.interrupt, fp_ts_1.option.some); }));
    });
}
function waitFiberSlot(slot) {
    return effect_1.effect.chain(slot.get, function (optFiber) {
        return fp_ts_1.pipeable.pipe(optFiber, fp_ts_1.option.fold(function () { return T.pure(undefined); }, function (f) { return T.asUnit(f.wait); }));
    });
}
function singleFiberSlot() {
    return M.bracket(ref.makeRef(fp_ts_1.option.none), interruptFiberSlot);
}
/**
 * Create a stream that switches to emitting elements of the most recent input stream.
 * @param stream
 */
function switchLatest(stream) {
    var source = M.managed.chain(streamQueueSource(stream), function (pull // read streams
    ) {
        return M.managed.chain(M.zip(
        // The queue and latch to push into
        M.encaseEffect(cq.boundedQueue(0)), M.encaseEffect(deferred.makeDeferred())), function (_a) {
            var pushQueue = _a[0], pushBreaker = _a[1];
            // The internal latch that can be used to signal failures and shut down the read process
            return M.managed.chain(M.encaseEffect(deferred.makeDeferred()), function (internalBreaker) {
                // somewhere to hold the currently running fiber so we can interrupt it on termination
                return M.managed.chain(singleFiberSlot(), function (fiberSlot) {
                    var interruptPushFiber = interruptFiberSlot(fiberSlot);
                    // Spawn a fiber that should push elements from stream into pushQueue as long as it is able
                    function spawnPushFiber(stream) {
                        var writer = fp_ts_1.pipeable.pipe(
                        // The writer process pushes things into the queue
                        into_(map_(stream, fp_ts_1.option.some), sink_1.queueSink(pushQueue)), 
                        // We need to trap any errors that occur and send those to internal latch to halt the process
                        // Dont' worry about interrupts, because we perform cleanups for single fiber slot
                        T.foldExit(function (e) { return internalBreaker.done(e); }, fp_ts_1["function"].constant(T.pure(undefined)) // we can do nothing because we will delegate to the proxy
                        ));
                        return T.applyFirst(interruptPushFiber, effect_1.effect.chain(T.fork(writer), function (f) { return fiberSlot.set(fp_ts_1.option.some(f)); }));
                    }
                    // pull streams and setup the push fibers appropriately
                    function advanceStreams() {
                        // We need a way of looking ahead to see errors in the output streams in order to cause termination
                        // The push fiber will generate this when it encounters a failure
                        var breakerError = effect_1.effect.chain(internalBreaker.wait, T.raised);
                        return effect_1.effect.foldExit(T.raceFirst(pull, breakerError), 
                        // In the event of an error either from pull or from upstream we need to shut everything down
                        // On managed unwind the active production fiber will be interrupted if there is one
                        function (cause) { return pushBreaker.cause(cause); }, function (nextOpt) {
                            return fp_ts_1.pipeable.pipe(nextOpt, fp_ts_1.option.fold(
                            // nothing left, so we should wait the push fiber's completion and then forward the termination
                            function () {
                                return fp_ts_1.pipeable.pipe(T.race(breakerError, waitFiberSlot(fiberSlot)), T.foldExit(function (c) { return pushBreaker.cause(c); }, // if we get a latchError forward it through to downstream
                                fp_ts_1["function"].constant(pushQueue.offer(fp_ts_1.option.none)) // otherwise we are done, so lets forward that
                                ));
                            }, function (next) { return T.applySecondL(spawnPushFiber(next), advanceStreams); }));
                        });
                    }
                    // We can configure this source now, but it will be invalid outside of running fibers
                    // Thus we can use managed.fiber
                    var downstreamSource = queueBreakerSource(pushQueue, pushBreaker);
                    return M.as(M.fiber(advanceStreams()), downstreamSource);
                });
            });
        });
    });
    return fromSource(source);
}
exports.switchLatest = switchLatest;
/**
 * Create a stream that switches to emitting the elements of the most recent stream produced by applying f to the
 * element most recently emitted
 * @param stream
 * @param f
 */
/* istanbul ignore next */
function chainSwitchLatest_(stream, f) {
    return switchLatest(map_(stream, f));
}
/* istanbul ignore next */
function chainSwitchLatest(f) {
    return function (s) { return chainSwitchLatest_(s, f); };
}
exports.chainSwitchLatest = chainSwitchLatest;
function interruptWeaveHandles(ref) {
    return effect_1.effect.chain(ref.get, function (fibers) {
        return T.asUnit(fp_ts_1.array.array.traverse(T.effect)(fibers, function (fiber) { return fiber[1].interrupt; }));
    });
}
// Track many fibers for the purpose of clean interruption on failure
var makeWeave = M.managed.chain(M.encaseEffect(ref.makeRef(0)), function (cell) {
    // On cleanup we want to interrupt any running fibers
    return M.managed.map(M.bracket(ref.makeRef([]), interruptWeaveHandles), function (store) {
        function attach(action) {
            return fp_ts_1.pipeable.pipe(fp_ts_1.apply.sequenceS(T.effect)({
                next: cell.update(function (n) { return n + 1; }),
                fiber: T.fork(action)
            }), T.chainTap(function (_a) {
                var next = _a.next, fiber = _a.fiber;
                return store.update(function (handles) { return __spreadArrays(handles, [[next, fiber]]); });
            }), T.chainTap(function (_a) {
                var next = _a.next, fiber = _a.fiber;
                return T.fork(T.applySecond(fiber.wait, store.update(fp_ts_1.array.filter(function (h) { return h[0] !== next; }))));
            }), T.asUnit);
        }
        return { attach: attach };
    });
});
/**
 * Merge a stream of streams into a single stream.
 *
 * This stream will run up to maxActive streams concurrently to produce values into the output stream.
 * @param stream the input stream
 * @param maxActive the maximum number of streams to hold active at any given time
 * this controls how much active streams are able to collectively produce in the face of a slow downstream consumer
 */
function merge_(stream, maxActive) {
    var source = M.managed.chain(streamQueueSource(stream), function (pull) {
        return M.managed.chain(M.encaseEffect(semaphore.makeSemaphore(maxActive)), function (sem) {
            // create the queue that output will be forced into
            return M.managed.chain(M.encaseEffect(cq.boundedQueue(0)), function (pushQueue) {
                // create the mechanism t hrough which we can signal completion
                return M.managed.chain(M.encaseEffect(deferred.makeDeferred()), function (pushBreaker) {
                    return M.managed.chain(makeWeave, function (weave) {
                        return M.managed.chain(M.encaseEffect(deferred.makeDeferred()), function (internalBreaker) {
                            // create a wave action that will proxy elements created by running the stream into the push queue
                            // if any errors occur, we set the breaker
                            function spawnPushFiber(stream) {
                                var writer = fp_ts_1.pipeable.pipe(
                                // Process to sink elements into the queue
                                into_(map_(stream, fp_ts_1.option.some), sink_1.queueSink(pushQueue)), 
                                // TODO: I don't think we need to handle interrupts, it shouldn't be possible
                                T.foldExit(function (e) { return internalBreaker.done(e); }, fp_ts_1["function"].constant(T.pure(undefined))));
                                return weave.attach(sem.withPermit(writer)); // we need a permit to start
                            }
                            // The action that will pull a single stream upstream and attempt to activate it to push downstream
                            function advanceStreams() {
                                var breakerError = effect_1.effect.chain(internalBreaker.wait, T.raised);
                                return effect_1.effect.foldExit(T.raceFirst(pull, // we don't want to pull until there is capacity
                                breakerError), function (c) { return pushBreaker.cause(c); }, // if upstream errored, we should push the failure downstream immediately
                                function (nextOpt // otherwise we should
                                ) {
                                    return fp_ts_1.pipeable.pipe(nextOpt, fp_ts_1.option.fold(
                                    // The end has occured
                                    fp_ts_1["function"].constant(fp_ts_1.pipeable.pipe(
                                    // We will wait for an error or all active produces to finish
                                    T.race(breakerError, sem.acquireN(maxActive)), T.foldExit(function (c) { return pushBreaker.cause(c); }, fp_ts_1["function"].constant(pushQueue.offer(fp_ts_1.option.none))))), 
                                    // Start the push fiber and then keep going
                                    function (next) {
                                        return T.applySecondL(sem.withPermit(spawnPushFiber(next)), fp_ts_1["function"].constant(advanceStreams()));
                                    }));
                                });
                            }
                            var downstreamSource = queueBreakerSource(pushQueue, pushBreaker);
                            return M.as(M.fiber(advanceStreams()), downstreamSource);
                        });
                    });
                });
            });
        });
    });
    return fromSource(source);
}
function merge(maxActive) {
    return function (stream) {
        return merge_(stream, maxActive);
    };
}
exports.merge = merge;
function chainMerge_(stream, f, maxActive) {
    return merge_(map_(stream, f), maxActive);
}
function chainMerge(maxActive, f) {
    return function (s) { return chainMerge_(s, f, maxActive); };
}
exports.chainMerge = chainMerge;
function mergeAll(streams) {
    return merge_(fromArray(streams), streams.length);
}
exports.mergeAll = mergeAll;
/**
 * Drop elements of the stream while a predicate holds
 * @param stream
 * @param pred
 */
function dropWhile_(stream, pred) {
    return chain_(peel_(stream, sink_1.drainWhileSink(pred)), function (_a) {
        var head = _a[0], rest = _a[1];
        return concat_(fromOption(head), rest);
    });
}
function dropWhile(pred) {
    return function (s) { return dropWhile_(s, pred); };
}
exports.dropWhile = dropWhile;
/**
 * Collect all the elements emitted by a stream into an array.
 * @param stream
 */
function collectArray(stream) {
    return into_(stream, sink_1.collectArraySink());
}
exports.collectArray = collectArray;
/**
 * Evaluate a stream for its effects
 * @param stream
 */
function drain(stream) {
    return into_(stream, sink_1.drainSink());
}
exports.drain = drain;
exports.URI = "matechs/Stream";
exports.stream = {
    URI: exports.URI,
    _CTX: "async",
    map: map_,
    of: function (a) { return once(a); },
    ap: function (sfab, sa) { return zipWith_(sfab, sa, function (f, a) { return f(a); }); },
    chain: chain_,
    as: as_,
    chainMerge: chainMerge_,
    chainSwitchLatest: chainSwitchLatest_,
    concat: concat_,
    concatL: concatL_,
    distinctAdjacent: distinctAdjacent_,
    drop: drop_,
    dropWhile: dropWhile_,
    filter: filter_,
    fold: fold_,
    foldM: foldM_,
    into: into_,
    intoLeftover: intoLeftover_,
    intoManaged: intoManaged_,
    mapM: mapM_,
    merge: merge_,
    peel: peel_,
    peelManaged: peelManaged_,
    scan: scan_,
    scanM: scanM_,
    take: take_,
    takeWhile: takeWhile_,
    takeUntil: takeUntil_,
    transduce: transduce_,
    zip: zip_,
    zipWith: zipWith_
};
/* extensions */
/* istanbul ignore next */
function getSourceFromObjectReadStream(stream) {
    return M.managed.chain(M.encaseEffect(T.sync(function () {
        var _a = su.queueUtils(), next = _a.next, ops = _a.ops, hasCB = _a.hasCB;
        stream.on("end", function () {
            next({ _tag: "complete" });
        });
        stream.on("error", function (e) {
            next({ _tag: "error", e: fp_ts_1.either.toError(e) });
        });
        stream.pipe(new stream_1.Writable({
            objectMode: true,
            write: function (chunk, _, callback) {
                next({ _tag: "offer", a: chunk });
                callback();
            }
        }));
        return { ops: ops, hasCB: hasCB };
    })), function (_a) {
        var hasCB = _a.hasCB, ops = _a.ops;
        return su.emitter(ops, hasCB);
    });
}
/* istanbul ignore next */
function fromObjectReadStream(stream) {
    return fromSource(getSourceFromObjectReadStream(stream));
}
exports.fromObjectReadStream = fromObjectReadStream;
// TODO: generalize this to batch over generic stream
/* istanbul ignore next */
function getSourceFromObjectReadStreamB(stream, batch, every) {
    return M.encaseEffect(T.sync(function () {
        var open = true;
        var leftover = [];
        var errors = [];
        stream.on("end", function () {
            open = false;
        });
        stream.on("error", function (e) {
            errors.push(e);
        });
        stream.pipe(new stream_1.Writable({
            objectMode: true,
            write: function (chunk, _, callback) {
                leftover.push(chunk);
                callback();
            }
        }));
        return T.delay(T.async(function (res) {
            if (leftover.length > 0) {
                res(fp_ts_1.either.right(fp_ts_1.option.some(leftover.splice(0, batch))));
            }
            else {
                if (errors.length > 0) {
                    res(fp_ts_1.either.left(errors[0]));
                }
                else {
                    if (open) {
                        res(fp_ts_1.either.right(fp_ts_1.option.some([])));
                    }
                    else {
                        res(fp_ts_1.either.right(fp_ts_1.option.none));
                    }
                }
            }
            // tslint:disable-next-line: no-empty
            return function (cb) {
                cb();
            };
        }), every);
    }));
}
/* istanbul ignore next */
function fromObjectReadStreamB(stream, batch, every) {
    return fromSource(getSourceFromObjectReadStreamB(stream, batch, every));
}
exports.fromObjectReadStreamB = fromObjectReadStreamB;
exports.Do = function () { return Do_1.Do(exports.stream); };
exports.sequenceS = Apply_1.sequenceS(exports.stream);
exports.sequenceT = Apply_1.sequenceT(exports.stream);
exports.sequenceOption = fp_ts_1.option.option.sequence(exports.stream);
exports.traverseOption = function (f) { return function (ta) {
    return fp_ts_1.option.option.traverse(exports.stream)(ta, f);
}; };
exports.wiltOption = function (f) { return function (wa) {
    return fp_ts_1.option.option.wilt(exports.stream)(wa, f);
}; };
exports.witherOption = function (f) { return function (ta) {
    return fp_ts_1.option.option.wither(exports.stream)(ta, f);
}; };
exports.sequenceEither = fp_ts_1.either.either.sequence(exports.stream);
exports.traverseEither = function (f) { return function (ta) {
    return fp_ts_1.either.either.traverse(exports.stream)(ta, f);
}; };
exports.sequenceTree = fp_ts_1.tree.tree.sequence(exports.stream);
exports.traverseTree = function (f) { return function (ta) { return fp_ts_1.tree.tree.traverse(exports.stream)(ta, f); }; };
exports.sequenceArray = fp_ts_1.array.array.sequence(exports.stream);
exports.traverseArray = function (f) { return function (ta) { return fp_ts_1.array.array.traverse(exports.stream)(ta, f); }; };
exports.traverseArrayWithIndex = function (f) { return function (ta) {
    return fp_ts_1.array.array.traverseWithIndex(exports.stream)(ta, f);
}; };
exports.wiltArray = function (f) { return function (wa) {
    return fp_ts_1.array.array.wilt(exports.stream)(wa, f);
}; };
exports.witherArray = function (f) { return function (ta) { return fp_ts_1.array.array.wither(exports.stream)(ta, f); }; };
exports.sequenceRecord = fp_ts_1.record.record.sequence(exports.stream);
exports.traverseRecord = function (f) { return function (ta) {
    return fp_ts_1.record.record.traverse(exports.stream)(ta, f);
}; };
exports.traverseRecordWithIndex = function (f) { return function (ta) {
    return fp_ts_1.record.record.traverseWithIndex(exports.stream)(ta, f);
}; };
exports.wiltRecord = function (f) { return function (wa) { return fp_ts_1.record.record.wilt(exports.stream)(wa, f); }; };
exports.witherRecord = function (f) { return function (ta) {
    return fp_ts_1.record.record.wither(exports.stream)(ta, f);
}; };
